import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errText } from "@/lib/api";
import { Shell } from "@/components/Shell";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Welcome, ${user.name}`);
      navigate("/moderator/dashboard");
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/moderator/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Shell>
      <div className="max-w-md mx-auto rise" data-testid="login-page">
        <p className="overline">Organiser access</p>
        <h1 className="font-display text-4xl font-black uppercase tracking-tight leading-none mt-2">
          Sign in
        </h1>

        <form onSubmit={submit} className="card p-6 mt-8" data-testid="login-form">
          <div>
            <label className="label">Email</label>
            <input required type="email" className="input" data-testid="login-email" value={form.email} onChange={set("email")} />
          </div>
          <div className="mt-4">
            <label className="label">Password</label>
            <input required type="password" className="input" data-testid="login-password" value={form.password} onChange={set("password")} />
          </div>
          <button className="btn-primary w-full mt-6" disabled={busy} data-testid="login-submit-btn">
            <LogIn size={15} />
            {busy ? "Working…" : "Sign in"}
          </button>
        </form>

        <div className="flex items-center gap-3 my-5">
          <div className="h-px flex-1 bg-[#252f3e]" />
          <span className="font-mono2 text-[11px] text-slate-500">OR</span>
          <div className="h-px flex-1 bg-[#252f3e]" />
        </div>

        <button onClick={google} className="btn-secondary w-full" data-testid="google-login-btn">
          Continue with Google
        </button>

        <p className="text-[11px] text-slate-500 mt-6 text-center" data-testid="signup-closed-note">
          Accounts are created from an invite link. Ask your organiser to send you one.
        </p>
      </div>
    </Shell>
  );
}
